<template>
  <div>
    <v-container style="margin-top:-15px">
        <v-row class="white">
          <v-col class="mb-5" cols="6">
            <h4 style="text-decoration:underline" class="secondary-color">
              <span id="FetchConfig" class="theme-main-color-darker">
                Fetch Config from PaymentIQ Backoffice
              </span>
            </h4>
            <div>
              <p class="caption">
                If you set fetchConfig to true,
                all fields in "Advanced" section will be disabled and configs will only be
                fetched from basic section and from your
                <span class="primary--text text--darken-2 bold-text">merchantCashierConfig</span> file in backoffice.
              </p>
              <div class="mb-2">
                <a
                  style="text-decoration:none"
                  target="_blank"
                  href="https://docu-portal.paymentiq.io/docs/apis_and_integration/cashier/cashier_parameter_details#fetchconfig">
                    <h4>Read more about this feature <v-icon>mdi-open-in-new</v-icon></h4>
                  </a>
              </div>
            </div>
            <v-select
              v-model="fetchConfigValue"
              filled
              label="Fetch config"
              :shaped="false"
              :items="fetchConfigValues"
            ></v-select>
          </v-col>
          <!-- Lets include a selection for setting a bootstrapper version as well -->
          <BootstrapperVersion />

        </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BootstrapperVersion from './BootsrapperVersion'

export default {
  name: 'Fetch-config-session',
  components: {
    BootstrapperVersion
  },
  data: () => ({
    fetchConfigValues: [false, true],
    fetchConfigValue: false
  }),
  props: {
    updateConfigs: { type: Function, required: true }
  },
  watch: {
    fetchConfigValue (val) {
      this.updateConfigs(val, 'fetchConfig')
    },
    fetchConfig (val) {
      this.fetchConfigValue = val
    }
  },
  computed: {
    ...mapState({
      fetchConfig: ({ context }) => context.config.fetchConfig
    })
  },
  created () {
    this.fetchConfigValue = this.fetchConfig
  }
}
</script>
